import { getUser } from "../../services/user";

const state = {
  user: {},
  authenticated: false
};

const getters = {
  user: state => state.user,
  authenticated: state => state.authenticated
};

const actions = {
  async fetchUser({ commit }) {
    try {
      const { data } = await getUser();
      const user = data;

      if (user) {
        commit("setAuthenticated", true);
        commit("setUser", user);
      } else {
        commit("setAuthenticated", false);
      }
    } catch (e) {
      commit("setAuthenticated", false);
      commit("setUser", null);
    }
  }
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setAuthenticated(state, payload) {
    state.authenticated = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
